<template>
    <div>
        <v-text-field v-model="printPaesse.search" prepend-inner-icon="mdi-magnify" placeholder clearable
                      label="Suchen" filled single-line hide-details dense class="mx-5 mt-2"/>
        <v-data-table :headers="headers" :items="passList" mobile-breakpoint="1" :search="printPaesse.search"
                      :items-per-page="itemsPerPage" @current-items="getFiltered">
            <template v-slot:header.passList="{ header }">
                <v-checkbox v-model="selectAll" @click.stop small class="mt-0 d-inline-block ml-3" hide-details>
                    <template v-slot:label>
                        <span style="font-size: 12px">Pässe (alle auswählen)</span></template>
                </v-checkbox>
            </template>
            <template v-slot:item.info="{ item }">
                <v-icon @click="openInfo(item)">mdi-information</v-icon>
            </template>
            <template v-slot:item.letzteAenderung="{ item }">
                {{getFormatedDate(item)}}
            </template>
            <template v-slot:item.typ="{ item }">
                <span v-if="item.typ==='geändert' || item.typ==='neu'">{{item.typ}}</span>
                <div v-else>
                    <tool-tip v-for="(icon, i) in item.typ" :key="i" :text="icon.toolTipPass">
                        <v-icon class="mr-2">{{ icon.icon }}</v-icon></tool-tip>
                </div>
            </template>
            <template v-slot:item.passList="{ item }">
                <div v-if="item.passList?.length>0" class="mb-1">
                    <v-chip v-for="(pass, i) in item.passList" :key="i" class="mr-1 mt-1">
                        <v-checkbox v-model="pass.selected"></v-checkbox>
                        {{pass.label}}
                    </v-chip>
                </div>
            </template>
        </v-data-table>
        <div class="text-right pr-5">
            <v-btn @click="createDruckListe()" color="primary">
                <v-icon class="mr-2">mdi-card-account-details</v-icon>Pass erzeugen</v-btn>
        </div>
        <!--
        <pre>
            {{passList}}
        </pre>-->
        <spieler-info :spieler="spielerInfo"/>
        <paesse-drucken-vorschau/>
    </div>
</template>

<script>
import SpielerInfo from "@/views/spielerTabelle/spielerInfo/spielerInfo";
import RouterServices from "@/utilities/services/router/routerServices";
import PaesseDruckenVorschau from "@/views/paesse/drucken/paesseDruckenVorschau";
import ToolTip from "@/components/elements/toolTip";
import TimeStamp from "@/services/timeStamp";

export default {
    name: "paesse-drucken-liste",
    components: {ToolTip, PaesseDruckenVorschau, SpielerInfo},
    computed: {
        printPaesse(){ return this.$store.state.local.printPaesse },
        passList(){ return this.printPaesse.passList },
        itemsPerPage(){ return this.search ? -1 : 10}
    },
    data: () => ({
        spielerInfo: null,
        headers: [
            { text: 'Pass-Nr.', value: 'passNr' },
            { text: 'Nachname', value: 'nachname' },
            { text: 'Vorname', value: 'vorname' },
            { text: 'Nat.', value: 'nationalitaet' },
            { text: 'Letzte Änd.', value: 'letzteAenderung' },
            { text: 'Auslöser', value: 'typ' },
            { text: '', value: 'info' },
            { text: 'zu druckende Pässe', value: 'passList' },
        ],
        selectAll: false,
    }),
    methods: {
        openInfo(spieler){
            this.spielerInfo = spieler.spielerObjekt
            this.spielerInfo.passNr = spieler.passNr
            RouterServices.pushRouteQueryParameter(this.$router, this.$route, 'action', 'spielerInfo' )
        },
        createDruckListe(){
            this.printPaesse.createDruckListe()
            RouterServices.pushRouteQueryParameter(this.$router, this.$route, 'passVorschau', true)
        },
        getFiltered(items){
            this.printPaesse.filteredItems = items
        },
        getFormatedDate(item){
            return item.letzteAenderung > 0 ?
                TimeStamp.getDateTextLocal(item.letzteAenderung) + ' ' + TimeStamp.getLocalTime(item.letzteAenderung, true) :
                '-'
        }
    },
    watch: {
        selectAll(to){ this.printPaesse.setSelected(to) }
    }
}
</script>

<style scoped>

</style>